import React, { useState } from "react";
import "../pages/NewLanding/NewLanding.scss";
import Logo from "./Comon/Logo/Logo";

const Footer = () => {
  const [logo, setLogo] = useState("/assets/logotm.png");

  return (
    <div className="footerWrapper mainContainerWrapper">
      <div className="topArea">
        <img className="footerLogo" src={logo} alt="logo" />
        <div className="footerSocial">
          <a href={'https://www.instagram.com/chiropractic_outcomes'}>
              <img src={"/assets/landing/ic_instagram@3x.png"} alt="instagram" />
          </a>

            <a href={'https://facebook.com/chiropracticoutcomes'}>
                <img src={"/assets/landing/ic_facebook@3x.png"} alt="facebook" />
            </a>
        </div>
      </div>
      <div className="bottomArea">
        <a href="http://chiropracticoutcomes.com/privacy">Privacy</a> | <a href="http://chiropracticoutcomes.com/terms">Terms of Use</a>
      </div>
    </div>
  );
};

export default Footer;
